<template>
    <div>
      <header-wrap></header-wrap>
      <secord-nav></secord-nav>
      <div class="top_line"></div>
        <div class="d_wrap">
          <h2 class="wrap_title">{{newInfo[`${currentLang.prefix}title`]}}</h2>
          <div class="wrap_one">
              <div>{{ newInfo.publish_time_txt ? newInfo.publish_time_txt : newInfo.create_time_txt }}</div>
              <span v-if="newInfo.activeNameText">{{newInfo.activeNameText}}</span>
          </div>
          <div class="wrap_two article_details" v-html="$convertPxToRem(newInfo[`${currentLang.prefix}content`])"></div>

          <!-- 返回按钮 -->
          <div style="width:100%;margin:30px 0;display:flex;justify-content:flex-end;border-bottom:1px solid #ccc;">
            <back-button>
              <i slot="prefixIcon"></i>
              返回上一级
              <i slot="suffixIcon" class="el-icon-arrow-right"></i>
            </back-button>
          </div>
        </div>
        <footer-wrap></footer-wrap>
    </div>
  </template>
      
  <script>
  import { mapGetters } from 'vuex'
  import { getCase } from "@/utils/http.js";
  export default {
    data() {
      return {
        newInfo:{}
      }
    },

    computed: {
      ...mapGetters([
        'currentLang'
      ]),
      newsPage() {
        return this.currentLang.config.newsPage
      },
      navbar() {
        return this.currentLang.config.navbar
      },
    },

    mounted(){
      
      this.getNewDetails()
    },
    methods: {
      getNewDetails() {
        getCase({
          id:this.$route.query.id,
        }).then(res => {
          console.log(res);
          if (res.code === 1) {
            this.newInfo = res.data;
            this.$set(this.newInfo,'activeNameText',this.$route.query.activeNameText)
          }
        });
      },
    }
  }
  </script>
  <style lang="scss" >
  .top_line{
    width: 100%;    
    height: 1px;
    background: #999999;
  }
  .d_wrap{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1000px;
    width: 1200px;
    margin: 80px auto 0 auto;

    .wrap_title {
      text-align: center;
    }

    .wrap_one{
      display: flex;
      font-size: 16px;
      justify-content: center;
      margin: 20px 0;
      text-align: center;
      div{
        color: #999999;
      }
      span{
        color: #30506F;
        margin-left: 20px;
      }
    }

    .wrap_two {
      margin-bottom: 80px;
      font-size: 16px;
      line-height: 1.8;
      // text-indent: 2rem;
      color: #666;
    }
    
    
  }
  .wrap_four{
      width: 100%;
      text-align: center;
      margin-top: 80px;
      padding: 80px 0;
      background: #F5F5F5;
      h2{
        color: #09395E;
        margin-bottom: 50px;
      }
      p{
        color: #656565;
        margin-top: 10px;
      }
      span{
        padding: 10px 25px;
        border-radius: 5px;
        color: white;
        background: #e8363e;
      }
    }
  h2{
    font-weight: normal;
  }
  </style>
      


// WEBPACK FOOTER //
// src/pages/news/nText.vue